
<div class="px-3">

  <page-title 
      icon="asterisk"
      title="Automation Freeze" 
      description="Freeze/Unfreeze creditors from automation">
  </page-title>

  <div class="flex align-items-center justify-content-between">
    <div class="font-bold rem-text-default text-lg">
      Frozen Creditors
    </div>
    <remitter-button
      label="Add a Creditor"
      icon='plus'
      severity="info"
      (click)="onClickAdd()"
    />
  </div>


 
  <ul class="w-25rem">
    @for(creditor of frozenCreditorsDisplay; track $index){
      <li class="mb-2">
        <div class="flex align-items-center justify-content-between">
              <div>{{creditor.CompanyName}}</div>
              <div class="flex align-items-center gap-2">
                <span>{{creditor.CreditorId}}</span>
                <span>
                      <icon-button
                        [pTooltip]="'Unfreeze '+creditor.CompanyName"
                        tooltipPosition='right'                       
                        [icon]="'trash'"
                        (click)="onDelete(creditor)"
                      />
                </span>
              </div>
        </div>
      </li>
    }
  </ul>
</div>

<p-sidebar 
    [(visible)]="isSideBarVisible" 
    [style]="{width: '30rem'}"
    position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium mb-6">Add Creditor to Frozen List</div>

      <div class="flex align-items-center justify-content-center mt-4">

          <creditor-autocomplete
            [(selectedCreditor)]="selectedCreditor"
            [creditors]="creditorOptions"
            (onSelect)="onSelectCreditor($event)"
          ></creditor-autocomplete>

      </div>
    </div>
  </p-sidebar>


<common-delete-modal
  [message]="'Are you sure you want to unfreeze '+creditorToDelete?.CompanyName"
  [visible]="isShowDeleteModal"
  (actionClicked)="onConfirmDelete()"
/>


